import request from '@/utils/request'

// 保存
export function savePrjFundActual(data) {
  return request({
    url: 'admin/portal/prjfundactual/save',
    method: 'post',
    data
  })
}

// 列表
export function listPrjFundActual(data) {
  return request({
    url: 'admin/portal/prjfundactual/list',
    method: 'post',
    data
  })
}

// 详情
export function infoPrjFundActual(id) {
  return request({
    url: 'admin/portal/prjfundactual/info/'+id,
    method: 'get'
  })
}

// 更新
export function updatePrjFundActual(data) {
  return request({
    url: 'admin/portal/prjfundactual/update',
    method: 'post',
    data
  })
}

// 批量删除
export function delPrjFundActual(data) {
  return request({
    url: 'admin/portal/prjfundactual/delete',
    method: 'post',
    data
  })
}

